module.exports = "/images/carousel-arrow.svg";